const graphvizVersion = "12.1.0";
export {graphvizVersion};
